import React from 'react';

export const Png = props => (
  <svg
    width="36"
    height="38"
    viewBox="0 0 36 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_dd_2613_7917)">
      <g clipPath="url(#clip0_2613_7917)">
        <rect
          x="1.59961"
          y="0.800049"
          width="32"
          height="32"
          rx="8"
          fill="url(#paint0_linear_2613_7917)"
        />
        <path
          d="M6.15918 18.2004H30.04C30.4943 18.2004 30.811 18.2008 31.0576 18.2209C31.2995 18.2407 31.4386 18.2777 31.5439 18.3313C31.7697 18.4463 31.9533 18.6299 32.0684 18.8557C32.122 18.961 32.1589 19.1001 32.1787 19.342C32.1988 19.5887 32.1992 19.9054 32.1992 20.3596V20.5598C32.1992 22.3585 32.1988 23.6836 32.1133 24.7307C32.0281 25.7732 31.8612 26.5055 31.5459 27.1243C30.9707 28.2531 30.0527 29.1711 28.9238 29.7463C28.3051 30.0616 27.5728 30.2285 26.5303 30.3137C25.4832 30.3993 24.158 30.3997 22.3594 30.3997H13.8398C12.0412 30.3997 10.7161 30.3993 9.66895 30.3137C8.62647 30.2285 7.89412 30.0616 7.27539 29.7463C6.14651 29.1711 5.22854 28.2531 4.65332 27.1243C4.33806 26.5055 4.17111 25.7732 4.08594 24.7307C4.0004 23.6836 4 22.3585 4 20.5598V20.3596C4 19.9054 4.00038 19.5887 4.02051 19.342C4.04027 19.1001 4.07723 18.961 4.13086 18.8557C4.24591 18.6299 4.42948 18.4463 4.65527 18.3313C4.76059 18.2777 4.89967 18.2407 5.1416 18.2209C5.38822 18.2008 5.70493 18.2004 6.15918 18.2004Z"
          fill="url(#paint1_linear_2613_7917)"
          stroke="#C1C335"
          strokeWidth="0.8"
        />
        <path
          d="M3.19922 12.6876C3.19922 13.5388 3.19922 13.9643 3.357 14.2928C3.51442 14.6205 3.77872 14.8848 4.10639 15.0422C4.43484 15.2 4.86041 15.2 5.71155 15.2H29.4392C30.3353 15.2 30.7833 15.2 31.1256 15.0256C31.4267 14.8722 31.6714 14.6274 31.8248 14.3263C31.9992 13.9841 31.9992 13.536 31.9992 12.64V12.4355C31.9992 8.54999 31.9992 6.60723 31.1812 5.39194C30.4662 4.32961 29.3563 3.59704 28.0984 3.35715C26.6594 3.08272 24.873 3.84639 21.3003 5.37374L16.0627 7.61279C15.9237 7.67222 15.8542 7.70194 15.7898 7.72783C13.4883 8.65322 10.8593 8.16531 9.0431 6.47571C8.99227 6.42843 8.93805 6.37575 8.82962 6.2704C8.66288 6.10839 8.5795 6.02739 8.52785 5.98137C6.51348 4.1868 3.31881 5.53712 3.20221 8.2324C3.19922 8.30152 3.19922 8.41776 3.19922 8.65025V12.6876Z"
          fill="url(#paint2_linear_2613_7917)"
        />
        <g filter="url(#filter1_di_2613_7917)">
          <path
            d="M9.44105 27V20.6H12.0848C12.564 20.6 12.9775 20.6937 13.3254 20.8812C13.6754 21.0667 13.9452 21.326 14.1348 21.6594C14.3244 21.9906 14.4192 22.376 14.4192 22.8156C14.4192 23.2573 14.3223 23.6437 14.1286 23.975C13.9369 24.3042 13.6629 24.5594 13.3067 24.7406C12.9504 24.9219 12.5275 25.0125 12.0379 25.0125H10.4067V23.7937H11.7504C11.9838 23.7937 12.1786 23.7531 12.3348 23.6719C12.4931 23.5906 12.6129 23.4771 12.6942 23.3312C12.7754 23.1833 12.8161 23.0115 12.8161 22.8156C12.8161 22.6177 12.7754 22.4469 12.6942 22.3031C12.6129 22.1573 12.4931 22.0448 12.3348 21.9656C12.1765 21.8865 11.9817 21.8469 11.7504 21.8469H10.9879V27H9.44105ZM20.5186 20.6V27H19.2061L16.6592 23.3062H16.6186V27H15.0717V20.6H16.4029L18.9217 24.2875H18.9748V20.6H20.5186ZM25.5812 22.6906C25.5458 22.5594 25.4937 22.4437 25.425 22.3437C25.3562 22.2417 25.2718 22.1552 25.1718 22.0844C25.0718 22.0135 24.9573 21.9604 24.8281 21.925C24.6989 21.8875 24.5573 21.8687 24.4031 21.8687C24.0927 21.8687 23.8239 21.9437 23.5968 22.0937C23.3718 22.2437 23.1979 22.4625 23.075 22.75C22.952 23.0354 22.8906 23.3823 22.8906 23.7906C22.8906 24.201 22.95 24.551 23.0687 24.8406C23.1875 25.1302 23.3593 25.351 23.5843 25.5031C23.8093 25.6552 24.0823 25.7312 24.4031 25.7312C24.6864 25.7312 24.926 25.6854 25.1218 25.5937C25.3198 25.5 25.4698 25.3677 25.5718 25.1969C25.6739 25.026 25.725 24.825 25.725 24.5937L26.0125 24.6281H24.4562V23.5H27.2156V24.3469C27.2156 24.9198 27.0937 25.4104 26.85 25.8187C26.6083 26.2271 26.275 26.5406 25.85 26.7594C25.427 26.9781 24.9406 27.0875 24.3906 27.0875C23.7802 27.0875 23.2437 26.9552 22.7812 26.6906C22.3187 26.426 21.9583 26.049 21.7 25.5594C21.4416 25.0677 21.3125 24.4844 21.3125 23.8094C21.3125 23.2844 21.3906 22.8187 21.5468 22.4125C21.7031 22.0042 21.9208 21.6583 22.2 21.375C22.4812 21.0917 22.8062 20.8771 23.175 20.7312C23.5458 20.5854 23.9448 20.5125 24.3718 20.5125C24.7427 20.5125 25.0875 20.5656 25.4062 20.6719C25.727 20.7781 26.0104 20.9281 26.2562 21.1219C26.5041 21.3156 26.7052 21.5458 26.8593 21.8125C27.0135 22.0792 27.1093 22.3719 27.1468 22.6906H25.5812Z"
            fill="url(#paint3_linear_2613_7917)"
            shapeRendering="crispEdges"
          />
        </g>
      </g>
      <rect
        x="1.99961"
        y="1.20005"
        width="31.2"
        height="31.2"
        rx="7.6"
        stroke="white"
        strokeWidth="0.8"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_2613_7917"
        x="-0.000390768"
        y="4.88162e-05"
        width="35.2"
        height="37.6"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="0.8"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_2613_7917"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.905882 0 0 0 0 0.905882 0 0 0 0 0.905882 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2613_7917"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="3.2"
          operator="erode"
          in="SourceAlpha"
          result="effect2_dropShadow_2613_7917"
        />
        <feOffset dy="3.2" />
        <feGaussianBlur stdDeviation="2.4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_2613_7917"
          result="effect2_dropShadow_2613_7917"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_2613_7917"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_di_2613_7917"
        x="9.44141"
        y="19.7125"
        width="17.7744"
        height="8.17495"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.8" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.743242 0 0 0 0 0.801739 0 0 0 0 0.306464 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2613_7917"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2613_7917"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.8" />
        <feGaussianBlur stdDeviation="0.8" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2613_7917"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2613_7917"
        x1="17.5996"
        y1="0.800049"
        x2="17.5996"
        y2="32.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F1F1F1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2613_7917"
        x1="18.0996"
        y1="17.8"
        x2="18.0996"
        y2="30.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C3BE35" />
        <stop offset="1" stopColor="#BADB66" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2613_7917"
        x1="17.5992"
        y1="0.799952"
        x2="17.5992"
        y2="15.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F4F4F4" />
        <stop offset="1" stopColor="#F4F4F4" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2613_7917"
        x1="18.2998"
        y1="19.4667"
        x2="18.2998"
        y2="25.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <clipPath id="clip0_2613_7917">
        <rect
          x="1.59961"
          y="0.800049"
          width="32"
          height="32"
          rx="8"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
